/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { VisitorTrackingData } from './VisitorTrackingData';
import type { AppMarketingData } from './AppMarketingData';
import type { WebMarketingData } from './WebMarketingData';

export interface DriverProvisionalRegistrationCreateAccountRequest {
    /** min length: 64, max length: 64 */
    token: string;
    app_marketing_data?: AppMarketingData;
    web_marketing_data?: WebMarketingData;
    visitor_tracking_data?: VisitorTrackingData;
    app_version?: string;
    preview_flow_id?: number;
    resolve_conflict_consent?: boolean;
}
